<script setup lang="ts">
import { computed } from 'vue';
import { Doughnut } from 'vue-chartjs';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
} from 'chart.js';
import BaseCard from '@/components/ui/BaseCard.vue';
import type { SourceCount } from '@/api/dashboard-types';

ChartJS.register(ArcElement, Tooltip, Legend);

const props = defineProps<{
  sources: SourceCount[];
  loading?: boolean;
}>();

// Chart.js default palette is explicitly permitted for doughnut charts per spec §3.
const chartData = computed(() => ({
  labels: props.sources.map((s) => s.source),
  datasets: [
    {
      data: props.sources.map((s) => s.count),
      hoverOffset: 4,
    },
  ],
}));

const chartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      position: 'bottom' as const,
      labels: { boxWidth: 12, padding: 12 },
    },
  },
};
</script>

<template>
  <BaseCard padding="md" data-testid="sources-breakdown">
    <template #header>
      <h2 class="text-section text-fg">By source</h2>
    </template>

    <div v-if="loading" class="h-48 bg-canvas-soft rounded animate-pulse" />

    <div v-else style="min-height: 192px; position: relative;">
      <Doughnut :data="chartData" :options="chartOptions" />
    </div>
  </BaseCard>
</template>
